import { format, parseISO } from 'date-fns';
import { de, enUS, es, fr, it, nl } from 'date-fns/locale';
import type { Locale } from 'date-fns';

type DateFnsFormatOptions = {
  locale?: Locale;
  weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
  firstWeekContainsDate?: number;
  useAdditionalWeekYearTokens?: boolean;
  useAdditionalDayOfYearTokens?: boolean;
};

const dateFnsLocales: Record<string, Locale> = { de, enUS, es, fr, it, nl };

const getSharedFormatOptions = (locale: string): DateFnsFormatOptions => {
  return {
    locale: dateFnsLocales[locale] || enUS,
  };
};

export const formatWithPattern = (
  isoString: string,
  pattern: string,
  locale: string,
): string => {
  if (!isoString) {
    return '';
  }

  // parseISO returns the parsed date in the local time zone
  return format(parseISO(isoString), pattern, getSharedFormatOptions(locale));
};

export const formatAsDate = (isoString: string, locale: string): string => {
  // Examples: "September 3rd, 2022", "September 9th, 2022", or "3. September
  // 2022" depending on the locale
  return formatWithPattern(isoString, 'PPP', locale);
};

export const formatAsShortDate = (
  isoString: string,
  locale: string,
): string => {
  // Examples: "Apr 29, 2022"
  return formatWithPattern(isoString, 'PP', locale);
};

export const formatAsDayOfWeek = (
  isoString: string,
  locale: string,
): string => {
  // Examples: "Friday", "Saturday"
  return formatWithPattern(isoString, 'eeee', locale);
};
